import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';

import CompetencyRequirementsIcon from 'components/Icons/CompetencyRequirements';
import LocationIcon from 'components/Icons/Location/Location';
import ShowCardIcon from 'components/Icons/ShowCard/ShowCard';
import SignOutIcon from 'components/Icons/SignOut/SignOut';
import UserGuideIcon from 'components/Icons/UserGuide/UserGuide';

import MediaQuery from 'react-responsive';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Body2 } from 'components/Typography';
import PromptDialog from 'components/PromptDialog';
import { appBarHeightLarge, appBarHeightSmall } from '../shellStyles';
import styles from './styles';

class UserProfileHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuAnchorEl: null,
            confirmLogoutDialogOpen: false
        };
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.clickDelegate = this.clickDelegate.bind(this);
    }

    showMenu(event) {
        this.setState({ menuAnchorEl: event.currentTarget });
    }

    hideMenu() {
        this.setState({ menuAnchorEl: null });
    }

    clickDelegate(func) {
        return () => {
            this.hideMenu();
            func.bind(this)();
        };
    }

    openUserGuide() {
        if (this.props.config.externalHelpEnabled)
            window.open(this.props.config.externalMobileAppsHelpURL, "_blank");
        else
            window.open("/api/v1/user-guide", "_blank");
    }

    cancelLogout = () => {
        this.setState({ confirmLogoutDialogOpen: false });
    };

    handleLogout = () => {
        this.setState({ confirmLogoutDialogOpen: true });
    };

    render() {
        const { menuAnchorEl } = this.state;
        const { cardCheckerCard, classes } = this.props;

        const isMenuOpen = Boolean(menuAnchorEl);
        const isLoggedIn = Boolean(cardCheckerCard);

        let userGuideText = "User Guide";
        if (this.props.config.externalHelpEnabled) {
            userGuideText = "Help Centre";
        }

        const renderMenu = (
            <MediaQuery maxWidth={768}>
                {(matches) => (
                    <Menu
                        open={isMenuOpen}
                        anchorReference="none"
                        onClose={this.hideMenu}
                        PopoverClasses={classes}
                        PaperProps={{
                            sx: {
                                top: matches ? appBarHeightSmall : appBarHeightLarge
                            }
                        }}
                    >
                        <div className={classes.userNamePanel}>
                            <div className={classes.name}>
                                {isLoggedIn ? `${cardCheckerCard.firstname} ${cardCheckerCard.surname}` : ''}
                            </div>
                            <Body2 className={classes.number}>
                                {isLoggedIn ? cardCheckerCard.skillSafeNo : ''}
                            </Body2>
                        </div>
                        <Divider className={classes.menuDivider} />
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.props.onShowCardClicked)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <ShowCardIcon />
                            </ListItemIcon>
                            Show Card
                        </MenuItem>
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.props.onLocationClicked)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <LocationIcon />
                            </ListItemIcon>
                            Change Location
                        </MenuItem>
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.props.onCompetencyRequirementsClicked)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <CompetencyRequirementsIcon />
                            </ListItemIcon>
                            Location Requirements
                        </MenuItem>
                        <Divider className={classes.menuDivider} />
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.openUserGuide)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <UserGuideIcon />
                            </ListItemIcon>
                            {userGuideText}
                        </MenuItem>
                        <Divider className={classes.menuDivider} />
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.handleLogout}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <SignOutIcon />
                            </ListItemIcon>
                            Log Out
                        </MenuItem>
                    </Menu>
                )}
            </MediaQuery>
        );

        return (
            <div className={isMenuOpen ? classes.open : ''}>
                {isLoggedIn &&
                    <React.Fragment>
                        <PromptDialog
                            open={this.state.confirmLogoutDialogOpen}
                            handleClose={this.cancelLogout}
                            title="Confirm Logout"
                            message="Are you sure you want to log out?"
                            showCancel={true}
                            cancelClicked={this.cancelLogout}
                            confirmClicked={this.props.onLogOutClicked} />

                        <Grid container className={classes.root}>
                            <Grid item>
                                <IconButton onClick={this.showMenu} className={classes.avatarButton} size="large" title="User photo">
                                    <Avatar className={classes.avatar} src={"data:image/png;base64," + cardCheckerCard.photo} alt="User photo" />
                                </IconButton>
                            </Grid>
                        </Grid>
                        {renderMenu}
                    </React.Fragment>
                }
            </div>
        );
    }
}

UserProfileHeader.propTypes = {
    onLogOutClicked: PropTypes.func.isRequired,
    onLocationClicked: PropTypes.func.isRequired,
    onShowCardClicked: PropTypes.func.isRequired,
    onCompetencyRequirementsClicked: PropTypes.func.isRequired,
    cardCheckerCard: PropTypes.object,
    config: PropTypes.object.isRequired
};

export default withStyles(UserProfileHeader, styles);